
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/yoga-meditation/additional-programs/[program]/[programInner]",
      function () {
        return require("private-next-pages/[region]/[language]/yoga-meditation/additional-programs/[program]/[programInner]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/yoga-meditation/additional-programs/[program]/[programInner]"])
      });
    }
  